import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import './Home.css';
import 'primereact/resources/themes/soho-light/theme.css'
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css'; // Certifique-se de ter o primeicons instalado
import logoK from './assets/grupok.png';
// --- COMPONENTES UI INTERNOS ---

const InputGroup = ({ label, error, required, icon, children }) => (
  <div className="input-group-container">
    <label className="input-label">
      {label} {required && <span className="required-mark">*</span>}
    </label>
    <div className={`input-wrapper ${error ? 'shake-animation error-border' : ''}`}>
      {icon && (
        <div className="input-icon">
          <i className={icon}></i>
        </div>
      )}
      {children}
      {error && (
        <div className="error-icon">
          <i className="pi pi-exclamation-circle"></i>
        </div>
      )}
    </div>
    {error && <span className="error-text">{error}</span>}
  </div>
);

const SelectCard = ({ selected, onClick, title }) => (
  <div
    onClick={onClick}
    className={`select-card ${selected ? 'selected' : ''}`}
  >
    {selected && <i className="pi pi-check" style={{ fontSize: '0.8rem' }}></i>}
    <span className="select-card-title">{title}</span>
  </div>
);

// --- COMPONENTE PRINCIPAL ---

export function Home() {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  // Estado do Formulário
  const [formData, setFormData] = useState({
    vaga: '',
    equipamento: '',
    local: '',
    centroDeCusto: '',

    termosAceitos: false,

    nome: '',
    email: '',
    cpf: '',
    telefone: '',
    tipoTelefone: 'Celular',
    dataNascimento: '',

    cep: '',
    endereco: '',
    bairro: '',
    cidade: '',
    uf: '',

    possuiCnh: false,
    categoriaCnh: '',
    escolaridade: '',
    tempoExperiencia: '',
    estaTrabalhando: false,
    resumoProfissional: '',
    salario: '',

    comoFicouSabendo: '',
    nomeIndicacao: '',
    jaTrabalhouGrupoK: false,
    empresaGrupoK: '',
    periodoInicio: '',
    periodoFim: '',
    possuiParente: false,
    nomeParente: '',
    grauParentesco: '',

    curriculo: null,
    ctps: null
  });

  const [errors, setErrors] = useState({});

  // --- EFEITOS E AUXILIARES ---

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setFormData(prev => ({
      ...prev,
      vaga: params.get("vaga") || "Candidatura Espontânea", // Valor padrão para evitar erro
      equipamento: params.get("equipamento") || "",
      local: params.get("local") || "Matriz",
      // Garante um valor padrão se não vier na URL (evita erro 500 se for obrigatório)
      centroDeCusto: params.get("centroDeCusto") || "0000"
    }));
  }, []);
  const handleNavClick = (targetStep) => {

    if (targetStep === step) return;

    if (targetStep < step) {
      setStep(targetStep);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    else if (targetStep === step + 1) {
      if (validateStep()) {
        setStep(targetStep);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        // Opcional: alert("Preencha os campos obrigatórios.");
      }
    }

  };
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let val = type === 'checkbox' ? checked : value;


    if (name === 'cpf') val = val.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4").substring(0, 14);
    if (name === 'telefone') val = val.replace(/\D/g, '').replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3").substring(0, 15);
    if (name === 'cep') val = val.replace(/\D/g, '').replace(/^(\d{5})(\d{3}).*/, "$1-$2").substring(0, 9);
    if (name === 'email') val = val.replace(/[ ]/g, "");


    setFormData(prev => ({ ...prev, [name]: val }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: null }));
  };
  const handlePhoneChange = (e) => {
    let val = e.target.value.replace(/\D/g, "");
    // Limita a 11 dígitos (DDD + 9 dígitos)
    if (val.length > 11) val = val.slice(0, 11);

    let formatted = val;

    // Aplica máscara apenas se tiver números suficientes
    if (val.length > 2) {
      // Começa com (XX) 
      formatted = `(${val.slice(0, 2)}) `;

      if (val.length < 11) {
        // Formato Fixo ou Celular incompleto: (XX) XXXX-XXXX
        // Pega os próximos 4 dígitos para a primeira parte
        if (val.length > 6) {
          formatted += `${val.slice(2, 6)}-${val.slice(6)}`;
        } else {
          formatted += val.slice(2);
        }
      } else {
        // Formato Celular Completo: (XX) XXXXX-XXXX
        formatted += `${val.slice(2, 7)}-${val.slice(7)}`;
      }
    }

    setFormData(prev => ({
      ...prev,
      telefone: formatted,
      // Atualiza o tipo internamente caso o backend precise, mas não mostra na UI
      tipoTelefone: val.length === 11 ? 'Celular' : 'Fixo'
    }));

    if (errors.telefone) setErrors(prev => ({ ...prev, telefone: null }));
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.current.show({ severity: 'error', summary: 'Erro', detail: `Arquivo muito grande. Máximo 10MB`, life: 1000 });
        return;
      }
      setFormData(prev => ({ ...prev, [fieldName]: file }));
    }
  };

  const removeFile = (fieldName) => {
    setFormData(prev => ({ ...prev, [fieldName]: null }));
  }

  const fetchCep = async (cepValue) => {
    const cleanCep = cepValue.replace(/\D/g, '');
    if (cleanCep.length === 8) {
      setLoading(true);
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
        const data = await response.json();

        if (!data.erro) {
          setFormData(prev => ({
            ...prev,
            endereco: data.logradouro,
            bairro: data.bairro,
            cidade: data.localidade,
            uf: data.uf
          }));
        } else {
          toast.current.show({ severity: 'error', summary: 'Erro', detail: `CEP não encontrado`, life: 1000 });
        }
      } catch (err) {
        console.error("Erro ao buscar CEP", err);
      } finally {
        setLoading(false);
      }
    }
  };

  // --- VALIDAÇÃO ---

  const validateStep = () => {
    let newErrors = {};
    let isValid = true;

    if (step === 1) {
      if (!formData.termosAceitos) {
        newErrors.termos = "Necessário aceitar os termos.";
        isValid = false;
      }
    }

    if (step === 2) {
      if (!formData.nome) newErrors.nome = "Obrigatório";
      if (!formData.email) newErrors.email = "Obrigatório";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "E-mail inválido";

      if (!formData.cpf) newErrors.cpf = "Obrigatório";
      else if (!/^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(formData.cpf)) newErrors.cpf = "CPF inválido";

      if (!formData.telefone) newErrors.telefone = "Obrigatório";
      else if (!/^\(\d{2}\) \d{4,5}-\d{4}$/.test(formData.telefone)) newErrors.telefone = "Telefone inválido";
      if (!formData.cep) newErrors.cep = "Obrigatório";
      if (!formData.endereco) newErrors.endereco = "Obrigatório";
      if (!formData.escolaridade) newErrors.escolaridade = "Selecione uma opção";
      if (formData.possuiCnh && !formData.categoriaCnh) newErrors.categoriaCnh = "Informe a categoria";

      if (Object.keys(newErrors).length > 0) isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const nextStep = () => {
    if (validateStep()) {
      setStep(prev => prev + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const prevStep = () => setStep(prev => prev - 1);

  // --- ENVIO ---

  const handleSubmit = async () => {
    if (!validateStep()) {
      toast.current.show({ severity: 'error', summary: 'Erro', detail: `Verifique os campos obrigatórios em vermelho.`, life: 1000 });
      return;
    }

    setLoading(true);

    try {
      // CORREÇÃO CRÍTICA NO PAYLOAD
      const payload = {
        nomeCompleto: formData.nome,
        tel: formData.telefone,
        email: formData.email,
        escolaridade: formData.escolaridade, // Deve enviar o CODE (ex: 'FI'), não o nome
        cep: formData.cep,
        endereco: formData.endereco,
        bairro: formData.bairro,
        uf: formData.uf,
        cidade: formData.cidade,

        // Booleanos
        possuiCnh: Boolean(formData.possuiCnh),
        estaTrabalhando: Boolean(formData.estaTrabalhando),
        jaTrabalhouGrupoK: Boolean(formData.jaTrabalhouGrupoK),
        possuiParente: Boolean(formData.possuiParente),

        categoria: formData.possuiCnh ? formData.categoriaCnh : "",
        tempoExperiencia: formData.tempoExperiencia,

        nosConteUmPouco: formData.resumoProfissional || "", // Garante string vazia se null

        // Converte Salário para Float (remove R$ se houver, troca vírgula por ponto)
        salario: formData.salario ? parseFloat(String(formData.salario).replace('R$', '').replace('.', '').replace(',', '.')) : 0,

        empresaGrupoK: formData.jaTrabalhouGrupoK ? formData.empresaGrupoK : "",
        periodo: (formData.jaTrabalhouGrupoK && formData.periodoInicio) ? `${formData.periodoInicio}|${formData.periodoFim}` : "",

        comoFicouSabendo: formData.comoFicouSabendo,
        funcionarioIndicacao: formData.comoFicouSabendo === 'IND' ? formData.nomeIndicacao : "",

        nomeParente: formData.possuiParente ? formData.nomeParente : "",
        grauParentesco: formData.possuiParente ? formData.grauParentesco : "",

        centroDeCusto: formData.centroDeCusto,
        cpf: formData.cpf,

        // CORREÇÃO DE DATA: Envia YYYY-MM-DD direto, mais seguro que ISOString completo
        dateAniversario: formData.dataNascimento ? formData.dataNascimento : null,

        vaga: formData.vaga
      };

      console.log("PAYLOAD JSON:", JSON.stringify(payload)); // OLHE SEU CONSOLE COM ISSO

      const response = await fetch("https://recrutamentogrupok.azurewebsites.net/candidatos/CriaCandidato", {
        method: "POST",
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.status === 201 || response.status === 200) {
        // Sucesso no cadastro -> Envia arquivos
        try {
          if (formData.curriculo) await uploadFile(formData.curriculo, "currículo");
          if (formData.ctps) await uploadFile(formData.ctps, "ctps");
        } catch (fileError) {
          console.warn("Aviso: Usuário criado, mas falha ao enviar arquivo.", fileError);
        }

        nextStep();
      } else {
        // Tenta ler o erro que o servidor devolveu
        const errorText = await response.text();
        console.error("ERRO 500 DETALHADO:", errorText);
        toast.current.show({ severity: 'error', summary: 'Erro', detail: "O usuário já está cadastrado", life: 1000 });
      }

    } catch (error) {
      console.error("Erro de conexão:", error);
      toast.current.show({ severity: 'error', summary: 'Erro', detail: "Erro de conexão. Verifique o console (F12).", life: 1000 });
    } finally {
      setLoading(false);
    }
  };

  const uploadFile = async (file, tipoDocumento) => {
    var url = new URL("https://recrutamentogrupok.azurewebsites.net/api/sharepointauth/UploadFile");
    var params = { tipoDocumento: tipoDocumento, userEmail: formData.email, userName: formData.nome }
    url.search = new URLSearchParams(params).toString()

    var data = new FormData();
    data.append('file', file);

    const res = await fetch(url, { method: "POST", body: data });
    if (!res.ok) throw new Error("Falha no upload");
  };

  // --- RENDERIZAÇÃO ---

  const Sidebar = () => (
    <div className="sidebar">
      <div className="sidebar-decor-1"></div>
      <div className="sidebar-decor-2"></div>

      <div className="sidebar-content">
        <div className="sidebar-header">
          <div className="sidebar-icon-box">
            <img src={logoK} alt="Logo K" className="sidebar-logo" />
          </div>
          <div>
            <h2 className="sidebar-title">Trabalhe conosco</h2>
          </div>
        </div>

        <div className="sidebar-steps">
          <div className="steps-line">
            {['Termos', 'Dados', 'Conclusão'].map((label, idx) => {
              const targetStep = idx + 1;
              const isActive = step === targetStep;
              const isCompleted = step > targetStep;

              // Define se o item é clicável (Passado ou Próximo imediato)
              const canNavigate = targetStep < step || targetStep === step + 1;

              return (
                <div
                  key={idx}
                  onClick={() => canNavigate && handleNavClick(targetStep)}
                  className={`step-item ${canNavigate ? 'cursor-pointer' : 'cursor-default'}`}
                  title={!canNavigate && step < targetStep ? "Complete a etapa atual primeiro" : ""}
                >
                  <div className={`step-dot ${isActive ? 'active' : isCompleted ? 'completed' : ''}`}>
                    {isCompleted && <i className="pi pi-check" style={{ fontSize: '10px', color: 'white' }}></i>}
                  </div>
                  <span className={`step-label ${isActive ? 'active' : ''}`}>
                    {label}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      <div className="sidebar-footer-card">
        {/* ... (conteúdo do card mantém igual) ... */}
        <h3 className="card-mini-title">Vaga Selecionada</h3>
        <p className="card-main-title">{formData.vaga}</p>
        <div className="card-info">
          <i className="pi pi-map-marker"></i> {formData.local}
        </div>
        <div className="progress-bar-bg">
          <div
            className="progress-bar-fill"
            style={{ width: step === 1 ? '33%' : step === 2 ? '66%' : '100%' }}
          ></div>
        </div>
        <p className="step-counter">{step}/3 Etapas</p>
      </div>
    </div>
  );
  const MobileHeader = () => (
    <div className="mobile-header">
      <div className="mobile-header-content">
        <h1 className="mobile-title">{formData.vaga}</h1>
        <p className="mobile-subtitle"><i className="pi pi-map-marker"></i> {formData.local}</p>
        <div className="mobile-steps">
          {[1, 2, 3].map(i => (
            <div key={i} className={`mobile-step-dot ${i <= step ? 'active' : ''}`}></div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="app-container">
      <Toast ref={toast}></Toast>
      <div className="sidebar-container-desktop"><Sidebar /></div>
      <div className="main-content">
        <MobileHeader />
        <div className="content-wrapper">

          {/* STEP 1: TERMOS */}
          {step === 1 && (
            <div className="fade-in-up">
              <div className="header-section">
                <h2 className="page-title">Bem-vindo(a)</h2>
                <p className="page-subtitle">Para iniciar seu processo seletivo, precisamos do seu consentimento.</p>
              </div>

              <div className="card">
                <div className="terms-scroll custom-scrollbar">
                  <p className="mb-4"><strong>TERMO DE ACEITE PARA TRATAMENTO DE DADOS PESSOAIS</strong></p>
                  <p className="mb-4">
                    Este documento visa registrar a manifestação livre, informada e inequívoca pela qual o usuário concorda
                    com o tratamento de seus dados pessoais para finalidade específica, em conformidade com a Lei nº 13.709 – Lei Geral de Proteção de Dados Pessoais (LGPD).Ao aceitar o presente termo, o usuário consente e
                    concorda que a empresa
                    <strong> SKAVA-MINAS MINERAÇÃO, CONTRUÇÕES E TRANSPORTE,</strong> CNPJ nº
                    03.353.341/0001-39, doravante denominada Controlador, tome decisões referentes ao tratamento de seus
                    dados pessoais, bem como realize o tratamento de seus dados pessoais, envolvendo operações como as
                    que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão,
                    distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da
                    informação, modificação, comunicação, transferência, difusão ou extração.
                  </p>

                </div>


                <div
                  onClick={() => handleInputChange({ target: { name: 'termosAceitos', type: 'checkbox', checked: !formData.termosAceitos } })}
                  className={`term-checkbox-container ${formData.termosAceitos ? 'checked' : ''}`}
                >
                  <div className={`checkbox-box ${formData.termosAceitos ? 'checked' : ''}`}>
                    {formData.termosAceitos && <i className="pi pi-check text-white"></i>}
                  </div>
                  <div>
                    <p className="term-title">Li e aceito os termos</p>
                    <p className="term-subtitle">Concordo com o processamento dos meus dados.</p>
                  </div>
                </div>
                {errors.termos && <p className="error-center"><i className="pi pi-exclamation-circle"></i> {errors.termos}</p>}
              </div>

              <div className="footer-actions right">
                <button onClick={nextStep} className="btn-primary">
                  Continuar <i className="pi pi-chevron-right"></i>
                </button>
              </div>
            </div>
          )}

          {/* STEP 2: DADOS */}
          {step === 2 && (
            <div className="fade-in-up pb-20">
              <div className="back-link" onClick={prevStep}>
                <i className="pi pi-chevron-left"></i> Voltar para Termos
              </div>

              <h2 className="page-title mb-6">Preencha sua ficha</h2>

              {/* Seção Dados pessoais */}
              <section className="form-section">
                <div className="section-bar"></div>
                <h3 className="section-title"><i className="pi pi-user section-icon"></i> Dados pessoais</h3>

                <div className="grid-2">
                  <div className="col-span-2">
                    <InputGroup label="Nome completo" required error={errors.nome} icon="pi pi-user">
                      <input
                        name="nome" value={formData.nome} onChange={handleInputChange}
                        className="input-field" placeholder="Seu nome completo"
                      />
                    </InputGroup>
                  </div>

                  <InputGroup label="CPF" required error={errors.cpf} icon="pi pi-id-card">
                    <input name="cpf" value={formData.cpf} onChange={handleInputChange} className="input-field" placeholder="000.000.000-00" />
                  </InputGroup>

                  <InputGroup label="Data de nascimento" required icon="pi pi-calendar">
                    <input type="date" name="dataNascimento" value={formData.dataNascimento} onChange={handleInputChange} className="input-field" />
                  </InputGroup>

                  <InputGroup label="E-mail" required error={errors.email} icon="pi pi-envelope">
                    <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="input-field" placeholder="nome@email.com" />
                  </InputGroup>

                  <div className="phone-grid">
                    {/*<div className="phone-type">
                        <InputGroup label="Tipo">
                          <select name="tipoTelefone" value={formData.tipoTelefone} onChange={handleInputChange} className="input-field select">
                            <option>Celular</option>
                            <option>Fixo</option>
                          </select>
                        </InputGroup>
                     </div>*/}

                    <div className="phone-number">
                      <InputGroup label="Telefone" required error={errors.telefone} icon="pi pi-phone">
                        <input type="tel" name="telefone" value={formData.telefone} onChange={handlePhoneChange} maxLength={15} className="input-field" placeholder="(00) 00000-0000" />
                      </InputGroup>
                    </div>
                  </div>
                </div>
              </section>

              {/* Seção Endereço */}
              <section className="form-section">
                <div className="section-bar"></div>
                <h3 className="section-title"><i className="pi pi-map-marker section-icon"></i> Endereço</h3>

                <div className="grid-3">
                  <InputGroup label="CEP" required error={errors.cep}>
                    <div className="relative">
                      <input
                        name="cep"
                        value={formData.cep}
                        onChange={(e) => { handleInputChange(e); if (e.target.value.replace(/\D/g, '').length >= 8) fetchCep(e.target.value); }}
                        className="input-field"
                        placeholder="00000-000"
                        maxLength={9}
                      />
                      {loading && <div className="spinner-input"></div>}
                    </div>
                  </InputGroup>

                  <div className="col-span-2">
                    <InputGroup label="Rua/Avenida" error={errors.endereco}>
                      <input name="endereco" value={formData.endereco} onChange={handleInputChange} className="input-field bg-readonly" />
                    </InputGroup>
                  </div>

                  <InputGroup label="Bairro">
                    <input name="bairro" value={formData.bairro} onChange={handleInputChange} className="input-field bg-readonly" />
                  </InputGroup>
                  <InputGroup label="Cidade">
                    <input name="cidade" value={formData.cidade} onChange={handleInputChange} className="input-field bg-readonly" />
                  </InputGroup>
                  <InputGroup label="UF">
                    <input name="uf" value={formData.uf} onChange={handleInputChange} className="input-field bg-readonly" />
                  </InputGroup>
                </div>
              </section>

              {/* Seção Profissional */}
              <section className="form-section">
                <div className="section-bar"></div>
                <h3 className="section-title"><i className="pi pi-briefcase section-icon"></i> Profissional</h3>

                <div className="mb-6">
                  <label className="input-label mb-2">Possui CNH?</label>
                  <div className="grid-2-sm">
                    <SelectCard title="Sim" selected={formData.possuiCnh} onClick={() => setFormData(p => ({ ...p, possuiCnh: true }))} />
                    <SelectCard title="Não" selected={!formData.possuiCnh} onClick={() => setFormData(p => ({ ...p, possuiCnh: false, categoriaCnh: '' }))} />
                  </div>
                  {formData.possuiCnh && (
                    <div className="mt-4 max-w-xs fade-in-down">
                      <InputGroup label="Categoria" error={errors.categoriaCnh}>
                        <input name="categoriaCnh" value={formData.categoriaCnh} onChange={handleInputChange} className="input-field" placeholder="Ex: AE, B, D" />
                      </InputGroup>
                    </div>
                  )}
                </div>

                <div className="grid-2">
                  <InputGroup label="Escolaridade" required error={errors.escolaridade}>
                    <select name="escolaridade" value={formData.escolaridade} onChange={handleInputChange} className="input-field select">
                      <option value="">Selecione...</option>

                      <option value="Fundamental Incompleto">Fundamental Incompleto</option>
                      <option value="Fundamental Completo">Fundamental Completo</option>
                      <option value="Médio Incompleto">Médio Incompleto</option>
                      <option value="Médio Completo">Médio Completo</option>
                      <option value="Técnico Cursando">Técnico Cursando</option>
                      <option value="Técnico Completo">Técnico Completo</option>
                      <option value="Superior Cursando">Superior Cursando</option>
                      <option value="Superior Completo">Superior Completo</option>
                      <option value="Pós Cursando">Pós Cursando</option>
                      <option value="Pós Completo">Pós Completo</option>
                    </select>
                  </InputGroup>

                  <InputGroup label="Experiência">
                    <select name="tempoExperiencia" value={formData.tempoExperiencia} onChange={handleInputChange} className="input-field select">
                      <option value="">Selecione...</option>

                      <option value="06 Meses">Sem experiência</option>
                      <option value="06 Meses">06 Meses</option>
                      <option value="1 Ano">1 Ano</option>
                      <option value="2 Anos">2 Anos</option>
                      <option value="3 Anos">3 Anos</option>
                      <option value="4 Anos">4 Anos</option>
                      <option value="Acima de 5 anos">Acima de 5 anos</option>
                    </select>
                  </InputGroup>
                </div>

                <div className="mb-6">
                  <label className="input-label mb-2">Está trabalhando atualmente?</label>
                  <div className="grid-2-sm">
                    <SelectCard title="Sim" selected={formData.estaTrabalhando} onClick={() => setFormData(p => ({ ...p, estaTrabalhando: true }))} />
                    <SelectCard title="Não" selected={!formData.estaTrabalhando} onClick={() => setFormData(p => ({ ...p, estaTrabalhando: false }))} />
                  </div>
                </div>

                <InputGroup label="Pretensão salarial/Último salário">
                  <input type="number" name="salario" value={formData.salario} onChange={handleInputChange} className="input-field" placeholder="R$ 0,00" />
                </InputGroup>

                <InputGroup label="Resumo profissional (Últimas experiências)">
                  <textarea
                    name="resumoProfissional"
                    value={formData.resumoProfissional}
                    onChange={handleInputChange}
                    className="input-field textarea"
                    placeholder="Descreva brevemente..."
                  ></textarea>
                </InputGroup>
              </section>

              {/* Seção Extras */}
              <section className="form-section">
                <div className="section-bar"></div>
                <h3 className="section-title"><i className="pi pi-building section-icon"></i> Informações adicionais</h3>

                {/* Grupo K Info */}
                <div className="mb-6">
                  <label className="input-label mb-2">Já trabalhou no Grupo K?</label>
                  <div className="grid-2-sm">
                    <SelectCard title="Sim" selected={formData.jaTrabalhouGrupoK} onClick={() => setFormData(p => ({ ...p, jaTrabalhouGrupoK: true }))} />
                    <SelectCard title="Não" selected={!formData.jaTrabalhouGrupoK} onClick={() => setFormData(p => ({ ...p, jaTrabalhouGrupoK: false }))} />
                  </div>
                </div>

                {formData.jaTrabalhouGrupoK && (
                  <div className="fade-in-down p-4 bg-gray-50 rounded mb-4">
                    <InputGroup label="Qual empresa?">
                      <select name="empresaGrupoK" value={formData.empresaGrupoK} onChange={handleInputChange} className="input-field select">
                        <option value="">Selecione...</option>
                        <option value="Skava Minas">Skava Minas</option>
                        <option value="Lokaminas">Lokaminas</option>
                        <option value="Consórcio">Consórcio</option>
                      </select>
                    </InputGroup>
                    <div className="grid-2">
                      <InputGroup label="Início">
                        <input type="date" name="periodoInicio" value={formData.periodoInicio} onChange={handleInputChange} className="input-field" />
                      </InputGroup>
                      <InputGroup label="Fim">
                        <input type="date" name="periodoFim" value={formData.periodoFim} onChange={handleInputChange} className="input-field" />
                      </InputGroup>
                    </div>
                  </div>
                )}

                {/* Indicação - CORRIGIDO: VALUES COM CÓDIGOS */}
                <InputGroup required label="Como ficou sabendo da vaga?">
                  <select name="comoFicouSabendo" value={formData.comoFicouSabendo} onChange={handleInputChange} className="input-field select">
                    <option value="">Selecione...</option>
                    <option value="Instagram">Instagram</option>
                    <option value="LinkedIn">LinkedIn</option>
                    <option value="Site da empresa">Site da empresa</option>
                    <option value="Sine">Sine</option>
                    <option value="Robert Half">Robert Half</option>
                    <option value="Feirão de Vagas">Feirão de Vagas</option>
                    <option value="Indicação">Indicação</option>
                  </select>
                </InputGroup>

                {formData.comoFicouSabendo === 'Indicação de (ex)funcionário' && (
                  <InputGroup label="Nome de quem indicou">
                    <input name="nomeIndicacao" value={formData.nomeIndicacao} onChange={handleInputChange} className="input-field" placeholder="Nome do funcionário" />
                  </InputGroup>
                )}

                {/* Parente */}
                <div className="mb-6 mt-4">
                  <label className="input-label mb-2">Possui parente na empresa?</label>
                  <div className="grid-2-sm">
                    <SelectCard title="Sim" selected={formData.possuiParente} onClick={() => setFormData(p => ({ ...p, possuiParente: true }))} />
                    <SelectCard title="Não" selected={!formData.possuiParente} onClick={() => setFormData(p => ({ ...p, possuiParente: false }))} />
                  </div>
                </div>

                {formData.possuiParente && (
                  <div className="fade-in-down grid-2">
                    <InputGroup label="Nome do parente">
                      <input name="nomeParente" value={formData.nomeParente} onChange={handleInputChange} className="input-field" />
                    </InputGroup>
                    <InputGroup label="Grau de parentesco">
                      <input name="grauParentesco" value={formData.grauParentesco} onChange={handleInputChange} className="input-field" />
                    </InputGroup>
                  </div>
                )}

                {/* Uploads */}
                <div className="grid-2 mt-6">
                  <div className="upload-zone group">
                    <input type="file" onChange={(e) => handleFileChange(e, 'curriculo')} className="file-input" accept=".pdf,.doc,.docx" />
                    {formData.curriculo ? (
                      <div className="file-preview">
                        <i className="pi pi-file-pdf text-green-500 mb-2" style={{ fontSize: '2rem' }}></i>
                        <span className="file-name">{formData.curriculo.name}</span>
                        <button onClick={(e) => { e.stopPropagation(); removeFile('curriculo') }} className="remove-btn">Remover</button>
                      </div>
                    ) : (
                      <>
                        <div className="upload-icon-box group-hover:scale">
                          <i className="pi pi-upload text-primary"></i>
                        </div>
                        <p className="upload-text">Upload currículo</p>
                        <p className="upload-subtext">PDF ou DOC (Max 10MB)</p>
                      </>
                    )}
                  </div>

                  <div className="upload-zone group">
                    <input type="file" onChange={(e) => handleFileChange(e, 'ctps')} className="file-input" accept="image/*,.pdf" />
                    {formData.ctps ? (
                      <div className="file-preview">
                        <i className="pi pi-id-card text-green-500 mb-2" style={{ fontSize: '2rem' }}></i>
                        <span className="file-name">{formData.ctps.name}</span>
                        <button onClick={(e) => { e.stopPropagation(); removeFile('ctps') }} className="remove-btn">Remover</button>
                      </div>
                    ) : (
                      <>
                        <div className="upload-icon-box group-hover:scale">
                          <i className="pi pi-upload text-primary"></i>
                        </div>
                        <p className="upload-text">Upload CTPS</p>
                        <p className="upload-subtext">Foto ou PDF (Max 10MB)</p>
                      </>
                    )}
                  </div>
                </div>
              </section>

              <div className="footer-bar">
                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  className={`btn-submit ${loading ? 'disabled' : ''}`}
                >
                  {loading ? (
                    <>Enviando...</>
                  ) : (
                    <>Enviar candidatura <i className="pi pi-check-circle"></i></>
                  )}
                </button>
              </div>
              <div className="mobile-spacer"></div>
            </div>
          )}

          {/* STEP 3: SUCESSO */}
          {step === 3 && (
            <div className="success-container fade-in-up">
              <div className="success-icon-box">
                <i className="pi pi-check text-green-600" style={{ fontSize: '3rem' }}></i>
              </div>
              <h1 className="success-title">Candidatura enviada!</h1>
              <p className="success-msg">
                O <b>Grupo K</b> O Grupo K agradece seu interesse. Nosso departamento de recrutamento fará a análise das informações e entrará em contato caso seu perfil seja selecionado.
              </p>

              <div className="success-details">
                <div className="detail-row">
                  <span className="detail-label">Vaga</span>
                  <span className="detail-badge">{formData.vaga}</span>
                </div>
              </div>

              <button
                onClick={() => window.location.reload()}
                className="btn-link"
              >
                Voltar ao início
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}